import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import ArticleSection from './components/ArticleSection';
import AboutSection from './components/AboutSection';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';
import { SITE_URL } from '@/constants/site';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: 'CSSBuy Spreadsheet',
      url: SITE_URL,
      description: 'Encontre o melhor CSSBuy Spreadsheet atualizado 2026. Guias completos, comparações entre agentes e links diretos para comprar produtos da China com segurança.',
      inLanguage: 'pt',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${SITE_URL}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: 'CSSBuy Spreadsheet',
      url: SITE_URL,
      description: 'Guia completo de CSSBuy Spreadsheet com links para comprar produtos da China com segurança.',
      sameAs: [
        'https://kaspreadsheet.com/',
      ],
    },
  ],
};

export default function Home() {
  return (
    <main>
      <JsonLd data={homeJsonLd as unknown as Record<string, unknown>} />
      <Navbar />
      <HeroSection />
      <FeatureGrid />
      <ArticleSection />
      <AboutSection />
      <CTASection />
      <TestimonialSection />
      <Footer />
    </main>
  );
}